import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["dealroomId", "filterBy"],
  _excluded2 = ["isOpen"],
  _excluded3 = ["selectedItem", "helperText"],
  _excluded4 = ["inputValue", "dlFilterBy", "filterBy", "isActive", "first", "setFirst"],
  _excluded5 = ["data", "error", "fetchMore"];
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
//@ts-nocheck
import { Table, TableBody, TableRow, TableCell, withStyles } from "components/mui";
import ListingStateChip from "components/ListingStateChip/ListingStateChip";
import { gql } from "@apollo/client";
import * as React from "react";
import NumberFormat from "react-number-format";
import numberWithCommas from "core/Utils/numberWithCommas";
import { ListingStateEnum, SelectableNodeEnum } from "utils/Enums";
import { WorkFlowStatusEnum } from "utils/Enums/index";
import DefaultAutocompleteInputField from "../../Fields/AutoComplete/DefaultAutocompleteInputField";
import DefaultSuggestionsPopper from "../../Fields/AutoComplete/DefaultSuggestionsPopper";
import AsyncSelect from "../AsyncSelect/AsyncSelect";
import { Query } from "@apollo/client/react/components";
import MasterlistingSelectFragment__MasterlistingNode from "./MasterlistingSelectFragment__MasterlistingNode";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function MasterlistingSelect(_ref) {
  var dealroomId = _ref.dealroomId,
    filterBy = _ref.filterBy,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dlFilterBy = dealroomId ? _JSON$stringify({
    dealroom__id: dealroomId,
    work_flow_status: WorkFlowStatusEnum.IN_DEALROOM.value
  }) : undefined;
  // we have to do it here to avoid the menu reseting the value of first when it rerenders
  var _React$useState = React.useState(10),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    first = _React$useState2[0],
    setFirst = _React$useState2[1];
  var filterByStringified = filterBy ? _JSON$stringify(filterBy) : undefined;
  var props = _objectSpread(_objectSpread({
    nodeType: SelectableNodeEnum.MASTERLISTINGS.name,
    placeholder: "Search for a listing"
  }, rest), {}, {
    renderSuggestions: function renderSuggestions(_ref2) {
      var isOpen = _ref2.isOpen,
        props = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/_jsx(DefaultSuggestionsPopper, _objectSpread(_objectSpread({}, props), {}, {
        open: isOpen,
        SuggestionsComponent: function SuggestionsComponent(props) {
          return /*#__PURE__*/_jsx(OptionsMenu, _objectSpread(_objectSpread({}, props), {}, {
            dlFilterBy: dlFilterBy,
            filterBy: filterByStringified,
            first: first,
            setFirst: setFirst
          }));
        },
        disablePortal: true
      }));
    },
    renderInputField: MasterlistingInputField
  });
  return /*#__PURE__*/_jsx(AsyncSelect, _objectSpread({}, props));
}

/* use a custom renderer to show listing information as input field help text */
function MasterlistingInputField(_ref3) {
  var _ListingStateEnum$val, _context, _context2;
  var ml = _ref3.selectedItem,
    helperText = _ref3.helperText,
    props = _objectWithoutProperties(_ref3, _excluded3);
  if (!ml || helperText) {
    // cant add helper text without the ML,
    // and dont want to override error helper text
    return /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread(_objectSpread({}, props), {}, {
      helperText: helperText
    }));
  }
  var listingStateDisplay = (_ListingStateEnum$val = _valuesInstanceProperty(ListingStateEnum)[ml.listingState].label) !== null && _ListingStateEnum$val !== void 0 ? _ListingStateEnum$val : "";
  var mlInfoHelperText = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(numberWithCommas(ml.sqft), " sqft, ")).call(_context2, ml.leaseTypeDisplay, ", ")).call(_context, listingStateDisplay);
  return /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread(_objectSpread({}, props), {}, {
    helperText: mlInfoHelperText
  }));
}

/*
 * Run a custom query so:
 * 1. we could use cursor pagination to load more.
 * 2. don't clutter <DefaultAsyncSuggestionsMenu /> with Masterlisting fragments
 */
function OptionsMenu(_ref4) {
  var inputValue = _ref4.inputValue,
    dlFilterBy = _ref4.dlFilterBy,
    filterBy = _ref4.filterBy,
    _ref4$isActive = _ref4.isActive,
    isActive = _ref4$isActive === void 0 ? true : _ref4$isActive,
    first = _ref4.first,
    setFirst = _ref4.setFirst,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx(Query, {
    query: QUERY,
    variables: {
      searchBy: inputValue || null,
      // need null b/c "" returns no results
      dlFilterBy: dlFilterBy,
      filterBy: filterBy,
      isActive: isActive,
      first: first
    },
    children: function children(_ref5) {
      var _context3, _data$allMasterlistin, _data$allMasterlistin2, _data$allMasterlistin3, _data$allMasterlistin4;
      var data = _ref5.data,
        error = _ref5.error,
        fetchMore = _ref5.fetchMore,
        other = _objectWithoutProperties(_ref5, _excluded5);
      if (error) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: "Error fetching data"
        });
      }
      return /*#__PURE__*/_jsx(OptionsTable, _objectSpread({
        masterlistings: _mapInstanceProperty(_context3 = (_data$allMasterlistin = data === null || data === void 0 || (_data$allMasterlistin2 = data.allMasterlistings) === null || _data$allMasterlistin2 === void 0 ? void 0 : _data$allMasterlistin2.edges) !== null && _data$allMasterlistin !== void 0 ? _data$allMasterlistin : []).call(_context3, function (e) {
          return e.node;
        }),
        onLoadMore: function onLoadMore() {
          setFirst(first + 10);
        },
        hasMore: (_data$allMasterlistin3 = data === null || data === void 0 || (_data$allMasterlistin4 = data.allMasterlistings) === null || _data$allMasterlistin4 === void 0 ? void 0 : _data$allMasterlistin4.pageInfo.hasNextPage) !== null && _data$allMasterlistin3 !== void 0 ? _data$allMasterlistin3 : false
      }, props));
    }
  });
}
function OptionsTable(_ref6) {
  var masterlistings = _ref6.masterlistings,
    getItemProps = _ref6.getItemProps,
    getMenuProps = _ref6.getMenuProps,
    onLoadMore = _ref6.onLoadMore,
    hasMore = _ref6.hasMore;
  return /*#__PURE__*/_jsx(StyledTable, {
    children: /*#__PURE__*/_jsxs(TableBody, _objectSpread(_objectSpread({}, getMenuProps()), {}, {
      children: [_mapInstanceProperty(masterlistings).call(masterlistings, function (masterlisting) {
        return /*#__PURE__*/_jsxs(TableRow, _objectSpread(_objectSpread({
          hover: true
        }, getItemProps({
          item: masterlisting
        })), {}, {
          tabIndex: -1,
          "data-testid": "listing-in-dealroom-select--suggestion",
          children: [/*#__PURE__*/_jsx(TableCell, {
            scope: "row",
            children: masterlisting.displayAddressWithFloor
          }), /*#__PURE__*/_jsx(TableCell, {
            children: /*#__PURE__*/_jsx(NumberFormat, {
              value: masterlisting.sqft,
              displayType: "text",
              thousandSeparator: true,
              suffix: " sqft"
            })
          }), /*#__PURE__*/_jsx(TableCell, {
            children: masterlisting.leaseTypeDisplay
          }), /*#__PURE__*/_jsx(TableCell, {
            children: /*#__PURE__*/_jsx(ListingStateChip, {
              listing: masterlisting
            })
          })]
        }), masterlisting.id);
      }), hasMore && /*#__PURE__*/_jsx(TableRow, {
        hover: true,
        onClick: function onClick() {
          onLoadMore();
        },
        style: {
          cursor: "pointer"
        },
        children: /*#__PURE__*/_jsx(TableCell, {
          scope: "row",
          variant: "footer",
          children: "Load more"
        })
      })]
    }))
  });
}
var StyledTable = withStyles({
  root: {
    minWidth: 400
  }
})(Table);
export var QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query MasterlistingSelectSearchQuery(\n        $searchBy: String\n        $dlFilterBy: JSONString\n        $filterBy: JSONString\n        $isActive: Boolean\n        $first: Int\n    ) {\n        allMasterlistings(\n            searchBy: $searchBy\n            first: $first\n            isActive: $isActive\n            sortBy: \"sqft\"\n            dlFilterBy: $dlFilterBy\n            filterBy: $filterBy\n        ) {\n            count\n            pageInfo {\n                hasNextPage\n                endCursor\n            }\n            edges {\n                node {\n                    id\n                    displayLabel # need this for AsyncSelect GET query\n                    listingState\n                    ...MasterlistingSelectFragment\n                }\n            }\n        }\n    }\n    ", "\n"])), MasterlistingSelectFragment__MasterlistingNode);